/**
 * Sidebar "Styles" filter group.
 *
 * Rendered by snippets/faceted-filters.liquid from the collection's quick_filters_map metafield
 * - the same lookup the quick filter tabs use, driving the same facet (the tag filter), so a
 * style ticked here lights the matching tab and vice versa. The entries are real checkboxes in
 * #CollectionFilterForm, so the theme's own ajax filtering handles them; this file only covers
 * the two things Liquid cannot:
 *
 * 1. Shopify exposes only a facet's 100 most common values and only reports a filter as active
 *    when its value is one of them. The rarer style tags sit outside that window: the filter
 *    still applies, but Liquid renders the checkbox unticked. The URL is the truth, so the
 *    checked state is re-derived from it after every load.
 *
 * 2. One label can stand for several tags ("Strappy" in a mixed collection). A checkbox holds
 *    one value, so the extra tags ride along as hidden inputs added and removed with it.
 *
 * It also keeps the form free of duplicates: the tab script preserves URL values as hidden
 * inputs, and once a checkbox carries the same value that copy is redundant.
 */
(function () {
  var FORM_ID = 'CollectionFilterForm';
  var INPUT_SELECTOR = 'input[data-style-filter]';
  var ITEM_ACTIVE_CLASS = 'filter-group__item--active';
  var EXTRA_ATTR = 'data-style-extra';

  function tagsOf(input) {
    var all = input.getAttribute('data-all-tags');
    return all ? all.split('|') : [input.value];
  }

  function findContainer(el) {
    var section = el.closest('.shopify-section');
    var container = section && section.querySelector('filter-container[data-ajax-filtering="true"]');
    return container && typeof container.ajaxLoadUrl === 'function' ? container : null;
  }

  // Hidden inputs for the tags the checkbox cannot carry itself (everything after the first).
  function syncExtraTags(input) {
    var form = input.form || document.getElementById(FORM_ID);
    if (!form) return;
    var tags = tagsOf(input);
    var primary = tags[0];

    form.querySelectorAll('input[' + EXTRA_ATTR + ']').forEach(function (extra) {
      if (extra.getAttribute(EXTRA_ATTR) === primary) extra.remove();
    });
    if (!input.checked) return;

    tags.slice(1).forEach(function (tag) {
      var extra = document.createElement('input');
      extra.type = 'hidden';
      extra.name = input.name;
      extra.value = tag;
      extra.setAttribute(EXTRA_ATTR, primary);
      input.parentNode.appendChild(extra);
    });
  }

  // A value carried by a ticked checkbox (or its extras) must not also sit in a plain hidden
  // input, or the form would send it twice.
  function dropDuplicateHidden(form, param) {
    var carried = [];
    form.querySelectorAll(INPUT_SELECTOR).forEach(function (input) {
      if (input.checked) carried = carried.concat(tagsOf(input));
    });
    form.querySelectorAll('input[type="hidden"][name="' + param + '"]:not([' + EXTRA_ATTR + '])').forEach(function (hidden) {
      if (carried.indexOf(hidden.value) !== -1) hidden.remove();
    });
  }

  function syncFromUrl() {
    var inputs = document.querySelectorAll(INPUT_SELECTOR);
    if (!inputs.length) return;
    var param = inputs[0].name;
    var current = new URLSearchParams(window.location.search).getAll(param);

    inputs.forEach(function (input) {
      var active = tagsOf(input).some(function (tag) { return current.indexOf(tag) !== -1; });
      input.checked = active;
      var item = input.closest('.filter-group__item');
      if (item) item.classList.toggle(ITEM_ACTIVE_CLASS, active);
      syncExtraTags(input);
    });

    var form = document.getElementById(FORM_ID);
    if (form) dropDuplicateHidden(form, param);
  }

  // Runs in the capture phase so it lands before the theme's own (debounced) change handler
  // reads the form.
  document.addEventListener('change', function (evt) {
    var input = evt.target;
    if (!input.matches || !input.matches(INPUT_SELECTOR)) return;
    syncExtraTags(input);
    var item = input.closest('.filter-group__item');
    if (item) item.classList.toggle(ITEM_ACTIVE_CLASS, input.checked);
    if (input.form) dropDuplicateHidden(input.form, input.name);
  }, true);

  // An applied-filter chip for a style removes every tag behind that label, not just one.
  document.addEventListener('click', function (evt) {
    var chip = evt.target.closest('[data-remove-tags]');
    if (!chip) return;
    // The param sits on the chip, since the Styles group (and its checkboxes) can be switched off.
    var param = chip.getAttribute('data-remove-param');
    var container = findContainer(chip);
    if (!param || !container) return; // the href clears the whole facet as a fallback

    var remove = chip.getAttribute('data-remove-tags').split('|');
    var url = new URL(window.location.href);
    var keep = url.searchParams.getAll(param).filter(function (value) {
      return remove.indexOf(value) === -1;
    });
    url.searchParams.delete(param);
    keep.forEach(function (value) { url.searchParams.append(param, value); });

    evt.preventDefault();
    container.ajaxLoadUrl(url.pathname + url.search);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncFromUrl);
  } else {
    syncFromUrl();
  }
  document.addEventListener('filters-loaded', syncFromUrl);
})();
